import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import UserService from '../../services/user/UserService'
import Propinsi from '../../utilities/Propinsi'
import KotaKab from '../../utilities/KotaKab'
import Negara from '../../utilities/Negara'
import { FaDownload } from 'react-icons/fa'
import DataTable from 'react-data-table-component'

const UpiModal = ({ showUpiModal, handleCloseUpiModal, setDisableForm }) => {

    let userService = useMemo(() => new UserService(), [])

    const columns = [
        {
            name: 'Nama UPI',
            cell: row => row['upiNama']
        },
        {
            name: 'Alamat UPI',
            cell: row => row['upiAlamat']
        },
        {
            name: 'Propinsi',
            cell: row => <Propinsi id={row['upiProp'].substring(0, 2)} />
        },
        {
            name: 'Kota',
            cell: row => <KotaKab id={row['upiKota']} />
        },
        {
            name: 'Negara',
            cell: row => <Negara id={row['upiNeg']} />
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Pilih</Tooltip>}>

                            <Button size="sm" variant="primary" onClick={() => pilihDataUpi(row)}>
                                <FaDownload /> Pilih
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            )
        }
    ]

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const pilihDataUpi = (row) => {
        // console.log(row)
        // setDataUpi(row)
        setDisableForm(true)
        handleCloseUpiModal(row)
    }

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true)
                const resUpi = await userService.listUpi(null, 0, 10)
                setListData(resUpi.data.data)
                setTotalData(resUpi.data.totalData)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                setListData([])
            }
        }
        fetchAllData()
    }, [userService])

    const handleChangePage = async (page) => {
        setLoading(true)
        const resUpi = await userService.listUpi(null, page - 1, size)
        setListData(resUpi.data.data)
        setTotalData(resUpi.data.totalData)
        setLoading(false)
    }

    const handlePerRowsChange = async (size, page) => {
        setLoading(true)
        const _res = await userService.listUpi(null, page - 1, size)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    const onChangeSearchUpi = async (e) => {
        setLoading(true)
        const _res = await userService.listUpi(e.target.value, 0, size)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    return (
        <>
            <Modal
                show={showUpiModal}
                onHide={handleCloseUpiModal}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6>Pilih Data UPI</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Cari Nama UPI</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Nama UPI" className="form-control-sm" onChange={(e) => onChangeSearchUpi(e)}/>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {loading && <Spinner />}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listData}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={totalData}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            persistTableHead={true}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpiModal